import { render } from "./setup.vue?vue&type=template&id=6a3b76d3&scoped=true&ts=true"
import script from "./setup.vue?vue&type=script&lang=ts"
export * from "./setup.vue?vue&type=script&lang=ts"

import "./setup.vue?vue&type=style&index=0&id=6a3b76d3&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3b76d3"]])

export default __exports__